/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "./store/AuthContext";

import LoginPage from "./View/LoginPage";
import RetDdDashboard from "./View/RetDdDashboard";

import PageNotFound from "./component/PageNotFound";

import Terms from "./View/Terms";

import NewMyProfile from "./View/NewMyProfile";
import MiniStatementReceipt from "./component/MiniStatementReceipt";
import UnauthorizedPage from "./component/UnauthorizedPage";

import PaymentFailed from "./View/PaymentFailed";
import PaymentSuccess from "./View/PaymentSuccess";

import LoginPageCopy from "./View/LoginPageCopy";
import LoginHistory from "./View/LoginHistory";
import Developers from "./View/Developers";
import SidenavBar from "./View/SidenavBar";
import ProjectDashboard from "./View/Biggbarains/ProjectDashboard";
import TaskBoard from "./View/Biggbarains/TaskBoard";
import Tickets from "./View/Biggbarains/Tickets";
import Clients from "./View/Clients";
import AttendanceGrid from "./View/Biggbarains/Attandance";
import LeaveReq from "./View/Biggbarains/LeaveReq";
import Holiday from "./View/Biggbarains/Holiday";
import AttandanceEmp from "./View/Biggbarains/AttandanceEmp";
import ClientProfile from "./View/Biggbarains/ClientProfile";
import SalarySlip from "./View/Biggbarains/SalarySlip";
import { CustomerUserdata } from "./View/customers/CustomerUserdata";
import AdminUtility from "./View/admin/AdminUtility";
import { Projectdata } from "./View/customers/Projectdata";
import TotalLeave from "./View/Biggbarains/TotalLeave";
import EmployeeCard from "./View/EmployeeCard";
import Employee from "./View/Employee";
// import { Salary } from "./View/Salary";
import EmployeeLeave from "./View/EmployeeLeave";
import Assets from "./View/Biggbarains/Assets";
import Invoices from "./View/Biggbarains/Invoices";
import Visits from "./View/Biggbarains/Visits";
import TableProjects from "./View/Biggbarains/TableProjects";
import ChatWidget from "./component/ChatWidget";
import { Salary } from "./View/Salary/Salary";

function App() {
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const isLoggedIn = authCtx.isLoggedIn;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login-copy" element={<LoginPageCopy />} />

          {/* <Route path="/sign-up" element={<SignUp />} /> */}
          <Route path="" element={<LoginPage />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>

          {/*end*/}
          <Route path="/terms-conditions" element={<Terms />} />

          <Route path="/bank-statement" element={<MiniStatementReceipt />} />
          {/* unauthorized is un-used for now */}
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="pgSuccess" element={<PaymentSuccess />} />
          <Route path="pgFailed" element={<PaymentFailed />} />

          {isLoggedIn && (
            <Route>
              <Route path="loginHistory" element={<LoginHistory />} />
              <Route path="loginHistory" element={<LoginHistory />} />

              {authCtx.user && authCtx.user.role === "Admin" && (
                // <Route path="admin" element={<SideNav />}>
                <Route path="admin" element={<SidenavBar />}>
                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="visits" element={<Visits />} />
                  {/* <Route path="my-profile" element={<MyProfile />} /> */}
                  <Route path="my_profile" element={<NewMyProfile />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  {/* <Route path="project" element={<ProjectDashboard />} /> */}
                  <Route path="project" element={<TableProjects />} />
                  <Route path="task" element={<TaskBoard />} />
                  <Route path="clients" element={<Clients />} />
                  <Route path="clientprofile" element={<ClientProfile />} />
                  <Route path="invoices" element={<Invoices />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="totalleave" element={<TotalLeave />} />
                  <Route path="employeeleave" element={<EmployeeLeave />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="salaryslip" element={<SalarySlip />} />
                  <Route path="salary" element={<Salary />} />
                  <Route path="assets" element={<Assets />} />
                  <Route path="employee" element={<Employee />} />

                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="utility" element={<AdminUtility />} />
                </Route>
              )}

              {authCtx.user && authCtx.user.role === "Developer" && (
                <Route path="developer" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="project" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="developers" element={<Developers />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="assets" element={<Assets />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="totalleave" element={<TotalLeave />} />
                  <Route path="employeeleave" element={<EmployeeLeave />} />
                  <Route path="project" element={<TableProjects />} />
                  <Route path="task" element={<TaskBoard />} />
                  <Route path="tickets" element={<Tickets />} />
                  <Route path="employee-salary" element={<SalarySlip />} />
                  <Route path="my_profile" element={<NewMyProfile />} />
                  <Route path="utility" element={<AdminUtility />} />
                </Route>
              )}
              {authCtx.user && authCtx.user.role === "Backend" && (
                <Route path="backend" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="project" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="developers" element={<Developers />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  {/* <Route path="leave" element={<LeaveReq />} /> */}
                  <Route path="employeeleave" element={<EmployeeLeave />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="project" element={<TableProjects />} />
                  {/* <Route path="project" element={<ProjectDashboard />} /> */}
                  <Route path="task" element={<TaskBoard />} />

                  <Route path="employee-salary" element={<SalarySlip />} />
                  <Route path="my_profile" element={<NewMyProfile />} />
                </Route>
              )}
              {authCtx.user && authCtx.user.role === "ASM" && (
                <Route path="asm" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="project" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />

                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="visits" element={<Visits />} />
                  <Route path="project" element={<TableProjects />} />
                  <Route path="employeeleave" element={<EmployeeLeave />} />
                  {/* <Route path="project" element={<ProjectDashboard />} /> */}
                  <Route path="task" element={<TaskBoard />} />

                  <Route path="my_profile" element={<NewMyProfile />} />
                </Route>
              )}
              {authCtx.user && authCtx.user.role === "Accounts" && (
                <Route path="accounts" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="project" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="developers" element={<Developers />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="project" element={<TableProjects />} />
                  <Route path="project" element={<ProjectDashboard />} />
                  <Route path="task" element={<TaskBoard />} />

                  <Route path="employee-salary" element={<SalarySlip />} />
                  <Route path="my_profile" element={<NewMyProfile />} />
                </Route>
              )}
              {authCtx.user && authCtx.user.role === "Trainee" && (
                <Route path="trainee" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="project" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="developers" element={<Developers />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="project" element={<TableProjects />} />
                  {/* <Route path="project" element={<ProjectDashboard />} /> */}
                  <Route path="task" element={<TaskBoard />} />

                  <Route path="employee-salary" element={<SalarySlip />} />
                  <Route path="my_profile" element={<NewMyProfile />} />
                </Route>
              )}
              {authCtx.user && authCtx.user.role === "Merchant" && (
                <Route path="merchant" element={<SidenavBar />}>
                  {authCtx?.user?.layout * 1 === 2 && (
                    <>
                      <Route path="projects" element={<ProjectDashboard />} />
                    </>
                  )}

                  <Route path="dashboard" element={<RetDdDashboard />} />
                  <Route path="users" element={<CustomerUserdata />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="loginHistory" element={<LoginHistory />} />
                  <Route path="developers" element={<Developers />} />
                  <Route path="attendance" element={<AttendanceGrid />} />
                  <Route path="leave" element={<LeaveReq />} />
                  <Route path="holiday" element={<Holiday />} />
                  <Route path="attandanceEmp" element={<AttandanceEmp />} />
                  <Route path="project" element={<TableProjects />} />
                  <Route path="task" element={<TaskBoard />} />
                  <Route path="invoice" element={<Invoices />} />
                  <Route path="tickets" element={<Tickets />} />
                  <Route path="employee-salary" element={<SalarySlip />} />
                  <Route path="my_profile" element={<NewMyProfile />} />
                </Route>
              )}
            </Route>
          )}
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;

// "/user/:userId" to pass id
